<!-- Notifications bell icon + text -->
<div class="flex items-center gap-2">
  <button mat-icon-button [matMenuTriggerFor]="notificationMenu">
    <mat-icon>notifications</mat-icon>
  </button>
  <span *ngIf="flagReminderMsg" class="flag-missing-font">
  Flag(s) missing for Week/Month!
  </span>
</div>

<!-- Notifications popup box -->
<mat-menu 
  #notificationMenu="matMenu" 
  class="notification-menu-panel" 
  [overlapTrigger]="false" 
  yPosition="below" 
  xPosition="after">

  <ng-template matMenuContent>
    <div class="w-full max-w-[400px]">

      <!-- Header (dark background) -->
      <div class="bg-gray-900 text-white px-4 py-2 rounded-t-md flex justify-between items-center">
        <span class="font-semibold">Notifications</span>
        <mat-icon class="text-white text-lg">notifications</mat-icon>
      </div>

      <!-- Content (white background) -->
      <div class="bg-white text-red-600 h-[200px] p-5 overflow-y-auto rounded-b-md">

        <!-- If there is no Flag Reminder -->
        <div *ngIf="!flagReminderMsg" class="py-6 px-8 flex flex-col items-center justify-center text-black">
          <div class="flex flex-col items-center justify-center w-16 h-16 rounded-full nonotifications--background">
            <mat-icon
              class="nonotifications--color text-3xl"
              [svgIcon]="'heroicons_outline:bell'">
            </mat-icon>
          </div>
          <div class="font-semibold tracking-tight mt-3"
               [appDynamicStyles]="{ 'font-size': {zoomout: '16px', zoomin: '14px'} }">
            No notifications
          </div>
        </div>
<!-- If there IS a Flag Reminder (full message goes inside the popup) -->
<div *ngIf="flagReminderMsg" class="flag-missing-notification-font font-sans text-sm py-2 px-3 ">
  <ul class="list-disc pl-4">
    <li>{{ flagReminderMsg }}</li>
  </ul>
</div>
      </div>
    </div>
  </ng-template>
</mat-menu>
